var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('GenericListTableV2',{attrs:{"parentID":this.parentID,"title":"Project Groups","headers":[
      { text: 'ID', value: 'id' },
      { text: 'Name', value: 'groupname' },
      { text: 'Description', value: 'description', editable: true},
      { text: 'Icon', value: 'button.icon', editable: true, type: 'icon' },
      { text: 'Icon Colour', value: 'button.class', editable: true, type: 'colour' }
    ],"url":"/schemas/projectgroups","apiResponseField":"projectgroups","onClickRoute":"ProjectGroupSingle","onClickParams":_vm.getOnClickParams}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }